import { useTranslation } from "react-i18next";
import { WHATSAPP_LINK } from "@/mocks/restaurant";

export default function WhatsAppFloat() {
  const { t } = useTranslation();

  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("float.aria")}
      className="press fixed bottom-4 right-4 z-50 flex h-[60px] w-[60px] items-center justify-center gap-3 rounded-full bg-[#25D366] text-white shadow-[0_6px_20px_rgba(0,0,0,0.35)] transition-colors hover:bg-[#1EBE5A] cursor-pointer md:bottom-6 md:right-6 md:w-auto md:px-6"
    >
      <i className="ri-whatsapp-fill text-3xl" aria-hidden="true" />
      <span className="hidden whitespace-nowrap font-body text-base md:inline">
        {t("float.label")}
      </span>
    </a>
  );
}